import React from "react";
import TextLoop from "react-text-loop";

const conctInfo = {
  phone: "054-2003332",
  email: " Maya@alt-delight.co.il",
};

const sliderContent = {
  name: "מאיה אלט",
  designation: "איפיון חווית משתמש",
  description: `אני מעצבת אפליקציות חווית משתמש ללקוחות בכל הגדלים, מתמחה ביצירת אתרים מסוגננים ומודרניים, חוויות משתמש, שירותי אינטרנט וחנויות מקוונות.`,
  btnText: "הורדת קורות חיים",
};

const SliderRtlAnimation = () => {
  return (
    <>
      {/*  Home Banner */}
      <section id="home" dir="rtl" className="home-banner">
        <div className="hb-top-fixed d-flex">
          <div className="hb-info">
            <div><a dir="ltr" href="tel:+972542003332">{conctInfo.phone}</a></div>
            <a href="mailto:Maya@alt-delight.co.il">
              {conctInfo.email}
            </a>
          </div>
          <div className="hb-lang">
            <ul className="nav">
              <li id="type">
                <a value="ltr" href="/">EN</a>
              </li>
              <li id="type" className="active">
                <a value="rtl" href="/HE">HE</a>
              </li>
            </ul>
          </div>
        </div>
        {/* End hp-top-fixed */}

        <div className="container">
          <div className="row full-screen align-items-center">
            <div className="col-lg-7">
              <div className="type-box">
                <h6 data-aos="fade-up" data-aos-duration="1200">
                  שלום, קוראים לי
                </h6>
                <h1
                  className="font-alt"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="100"
                >
                  {sliderContent.name}
                </h1>
                <div
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="200"
                >
                  <TextLoop>
                    <p className="loop-text lead">עיצוב אתרי אינטרנט</p>
                    <p className="loop-text lead">איפיון חווית משתמש</p>
                    <p className="loop-text lead">מחקר התנהגות לקוח</p>
                  </TextLoop>
                </div>

                <p
                  className="desc"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="300"
                >
                  {sliderContent.description}
                </p>
                <div
                  className="mt-4"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="400"
                >
                  <a
                    className="px-btn px-btn-white"
                    href="/resume.pdf"
                    download
                  >
                    {sliderContent.btnText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Container*/}
        <div
          className="hb-me"
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "img/slider/home-banner-rtl.png"
            })`,
          }}
        ></div>
      </section>

      {/* End Home Banner  */}
    </>
  );
};

export default SliderRtlAnimation;
